import React from "react";
import { Link } from "react-router-dom";
import { Check, Crown, Award, Medal, Store } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { sponsorTiers, exhibitionStall, otherSponsorships } from "../mock";
import { useReveal } from "../hooks/useReveal";

const tierMeta = {
  Platinum: { icon: Crown, badge: "bg-navy-700" },
  Gold: { icon: Award, badge: "bg-brand" },
  Bronze: { icon: Medal, badge: "bg-amber-600" },
};

const Sponsorship = () => {
  useReveal();
  return (
    <div>
      <PageHeader title="Sponsorship Opportunities" crumb="Sponsorship" subtitle="Showcase your brand to 2,500+ healthcare professionals across three days of science." />

      <section className="section-pad bg-white">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="grid lg:grid-cols-3 gap-6">
            {sponsorTiers.map((t) => {
              const meta = tierMeta[t.name];
              const Icon = meta.icon;
              return (
                <div key={t.name} className="reveal card-hover rounded-3xl bg-white border border-slate-100 shadow-sm p-7">
                  <div className="flex items-center justify-between">
                    <div className={`w-12 h-12 rounded-xl ${meta.badge} flex items-center justify-center`}><Icon className="w-6 h-6 text-white" /></div>
                    <div className="text-right"><div className="font-display font-extrabold text-2xl text-navy-900">{t.price}</div><div className="text-xs text-slate-500">{t.note}</div></div>
                  </div>
                  <h3 className="mt-5 font-display font-bold text-xl text-navy-900">{t.name} Sponsor</h3>
                  <ul className="mt-4 space-y-2.5">
                    {t.benefits.map((b) => (<li key={b} className="flex items-start gap-2.5 text-sm text-slate-600"><Check className="w-4 h-4 text-brand mt-0.5 shrink-0" /> {b}</li>))}
                  </ul>
                  <Link to="/contact" className="mt-6 block text-center rounded-full bg-navy-800 hover:bg-navy-900 text-white font-semibold py-3 transition-colors">Enquire Now</Link>
                </div>
              );
            })}
          </div>

          <div className="mt-8 reveal rounded-3xl bg-navy-800 text-white p-7 flex flex-col md:flex-row md:items-center gap-6 justify-between">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-xl bg-brand flex items-center justify-center shrink-0"><Store className="w-6 h-6 text-white" /></div>
              <div><h3 className="font-display font-bold text-xl">{exhibitionStall.title}</h3><p className="text-sm text-slate-300 mt-1">Includes: {exhibitionStall.includes.join(" \u00b7 ")}</p></div>
            </div>
            <div className="flex gap-3">
              {exhibitionStall.options.map((o) => (<div key={o.size} className="text-center bg-white/5 rounded-2xl px-5 py-3 border border-white/10"><div className="font-display font-bold">{o.price}</div><div className="text-xs text-slate-400">{o.size}</div></div>))}
            </div>
          </div>
        </div>
      </section>

      <section className="pb-20 bg-white">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <h2 className="font-display font-bold text-2xl md:text-3xl text-navy-900 text-center mb-10">Other Branding Opportunities</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {otherSponsorships.map((o) => (
              <div key={o.title} className="reveal rounded-2xl bg-slate-50 border border-slate-100 p-5 hover:border-brand-300 transition-colors">
                <div className="font-display font-extrabold text-brand text-lg">{o.price}</div>
                <h4 className="mt-1 font-semibold text-navy-900">{o.title}</h4>
                <p className="mt-1.5 text-xs text-slate-500 leading-relaxed">{o.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Sponsorship;
